import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SamplingMissionView from '../mission/SamplingMissionView';
import SampleScheduleView from '../schedule/SampleScheduleView';
import SamplingMap from '../map/SamplingMap';
import Robots from '../Robots';
import RobotPanel from '../robot/RobotPanel';
import { getCurrentMission, getCurrentSession, getJobKmlFromZip, textToZip } from '../../dataModelHelpers';
import {
  AirtableViewIdLookup,
  DROPOFF_VIEW_NAME,
  JOBS_COMPLETED_VIEW_NAME,
  JOBS_RUN_VIEW_NAME,
} from '../../airtable_crm';
import EventBus, { onRobotMessage, removeRobotMessageCallback, RobotNumberMessage } from '../../EventBus';
import logger from '../../logger';
import {
  alertConfirm,
  alertError,
  alertSuccess,
  alertInfo,
  alertWarnConfirm,
  alertWarn,
  alertFullScreen,
} from '../../alertDispatcher';
import { CreatedOrDeletedParams, MISSION_EVENTS } from '../../missionEvents';
import {
  SetStateAsync,
  convertProjection4329,
  getUserPosition,
  roundToIncrement,
  setStateAsync,
  uuidv4,
} from '../../utils';
import { calculateWaypointNumber } from './calculateWaypointNumber';
import { handleResampleCheck } from './handleResampleCheck';
import { genDropoffGeoJSON, genPullinGeoJSON, updateBoundaryProperties } from '../schedule/helpers/geojson';
import {
  FieldShape,
  fieldGeometries,
  fieldLabelPoint,
  fieldOrderOverlay,
  shapeFromParts,
} from '../map/helpers/fieldOrder';
import { errorTone } from '../../alertTones';
import { isMobile } from 'react-device-detect';
import { BOX_EVENTS, dispatchActiveBoxUpdated } from '../../boxEvents';
import { flatten, orderBy } from 'lodash';
import SlideoutTextBox from '../mission/sampling/OperatorNotes';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ListItemText from '@mui/material/ListItemText';
import LocalAtRecord from '../../db/LocalAtRecordClass';
import { dispatchRosMsgPeer, dispatchRosMsgPub } from '../../RobotConnection';
import { INBOUND_TOPICS, OUTBOUND_TOPICS, hmiInboundTopic, rosEventKey } from '../../types/rosTopics';
import { TaskName } from '../../db/TaskClass';
import {
  CoringAllowedState,
  LatLonSource,
  MissionView,
  OnLoading,
  RobotArmType,
  RobotConnectionStatus,
  RobotNavControl,
  RobotState,
  ScheduleFeature,
  ScheduleItem,
  SettingsAccessLevel,
} from '../../types/types';
import { RosMissionMsg, RobotControlRole, CoreMsg, RosPosition, DumpCompleteMsg, StartAt } from '../../types/rosmsg';
import {
  RecoveryFileListResponse,
  extractRogoJobIDs,
  getRecoveryFile,
  getRecoveryList,
} from '../../recoveryServerUtils';
import S3 from '../../aws';
import { Feature, FeatureCollection, MultiPolygon, Point, Polygon } from 'geojson';
import { PDFViewer } from '../utils';
import { DialogTitle, Modal } from '@mui/material';
import { _MS_PER_MIN, COLOR, MM_PER_INCH, MS_PER_HOUR } from '../../constants';
import {
  setSampleSelected,
  DisableBarcodeEnforcement,
  MissionEventStore,
  BarcodeSelectionModeStore,
} from '../../sampleSelectionHelpers';
import { BarcodeProcessorStateStore, checkGapError, setSampleBarcodes } from '../../barcodes';
import { inProcessSimulator } from '../../simulatorTools';
import { Attachment, Sample, SampleBox, SoilDumpEvent, Waypoint, Zone } from '../../db';
import BoxHistoryView from '../BoxHistoryView';
import { CHANGE_EVENTS, ChangeReasonPopupResult, ShowChangeTypeSelectorPopup } from '../../changeReasonHelpers';
import ChangeTypeReasonSelector from '../mission/sampling/SkipSampleReasonSelector';
import * as Sentry from '@sentry/react';
import { JobsFieldSet } from '@rogoag/airtable/crm';
import { isBarcodeValidBag } from '../../barcode_rules';
import { Coordinate } from 'ol/coordinate';
import { postCustomerNotificiation as postCustomerNotification } from '../../sns_utilities';
import { PRINTER_CONFIG, PRINTER_SIZE_4_6, getPrintURLFromConfig } from '../robot/configs/PrinterConfig';
import BoxExitInterview from '../mission/sampling/BoxExitInterview';
import { generateBoxCheckin } from '../../pdfcheckin';
import SamplingHelperView from '../mission/SamplingHelperView';
import { proxyGetFiles, proxyPublishHelperData } from '../../proxyServerUtils';
import { dispatchSamplesUpdated, MAP_EVENTS } from '../../mapEvents';
import {
  CoreCountEnforcementEnabled,
  SimulatorEnabledStorage,
  MapNearbyAutoZoomEnabled,
  RobotArmOffsetX,
  RobotArmOffsetY,
  MobileHelperEnabled,
  BigFieldMode,
} from '../../db/local_storage';
import SamplingEntranceInterview from '../mission/sampling/SamplingEntranceInterview';
import CoreCompletion from '../../services/CoreCompletion';
import { ManualMeasurementDialogParameters } from '../../services/ManualMeasurementsChecker';
import ManualMeasurementDialog from './ManualMeasurementDialog';
import { saveRecoveryZip } from '../../services/recovery-zip/RecoveryZipService';
import {
  calculateOrigin,
  calculateSampleUpdates,
  canHandlePositionUpdate,
} from '../../services/TargetCoordinateService';
import { closeBox } from '../../redux/features/boxes/boxesSlice';
import { restartPeriodicDbSync, saveDbToRecoveryServer } from '../../db/datamanager';
import { DB_SAVE_REASONS } from '../../services/RecoveryServerDbManager';
import { IMissionLoader } from '../../services/mission-loading/MissionLoaderCommon';
import OriginalMissionLoader from '../../services/mission-loading/original/OriginalMissionLoader';
import { getLocalAtSearch } from '../../db_ops/airtable_search_ops';

interface SamplingTaskProps {
  tab: string;
  task: TaskName;
  missionActive: string;
  connectionStatus: RobotConnectionStatus;
  devMode: boolean;
  showRecoveryPopup: () => void;
  showDatabasesPopup: () => void;
  elevatePermissions: () => void;
  accessLevel: SettingsAccessLevel;
  onLoading: OnLoading;
  closeBox: typeof closeBox;
}

interface SamplingTaskState {
  autoSync: boolean;
  controlRole: RobotControlRole;
  currentMissionChecksum?: string;
  depthLocked: boolean;
  drillDepthDisplay?: number;
  drillDepthRaw?: number;
  drillDepthOffset?: number;
  filledSamples?: number;
  hmiVisible: boolean;
  lastSyncTimestamp?: string;
  loadingSchedule: boolean;
  missionDepth?: number;
  navWarningDirections: string;
  navigationPopupVisible: boolean;
  growerNotificationPromptVisible: boolean;
  navigationJobInstanceId: number;
  operatorNotes: string;
  operatorNotesDialogOpen: boolean;
  outOfSync: boolean;
  robotMission?: RosMissionMsg;
  scannerActive: boolean;
  scheduleFeatures: ScheduleFeature[];
  scheduleItems: ScheduleItem[];
  sampledItems: LocalAtRecord<JobsFieldSet>[];
  offlineItems: LocalAtRecord<JobsFieldSet>[];
  syncInProgress: boolean;
  totalSamples?: number;
  trackingOverride: boolean;

  presentSample?: Sample;
  closeSample?: Sample;
  confirmFullscreenButton: boolean;

  robotNavControlState: RobotNavControl;
  soilInBucket: boolean;
  robotArmType: RobotArmType;
  // TODO these should be a single object
  disableBarcodeTracking: boolean;
  robotState: RobotState;
  reasonSelectorOptions?: ShowChangeTypeSelectorPopup;

  manualMeasurementDialogOpen: boolean;
  manualMeasurementDialogParameters: ManualMeasurementDialogParameters | null;

  activeBox: SampleBox | undefined;
  boxesNeedReprint: {
    boxId: string;
    instanceId: number;
    boxMissions: {
      fieldName: string;
      instanceId: number;
      numSamples: number;
    }[];
  }[];
  boxToClose?: SampleBox;
  printerConfig: PRINTER_CONFIG;
  printURL: string;
  boxPdf?: {
    dataUrl: string;
    downloadName: string;
  };
  allBoxes: SampleBox[];
  boxInstanceId?: number;
  boxMissions: {
    fieldName: string;
    instanceId: number;
    numSamples: number;
  }[];
  // TODO not totally happy this this implementation... still see behavior related
  // to reprints that doesn't make sense
  boxPdfPreviewVisible: boolean;
  boxCloseTitle: string;
  currentMissionPhotos: string[];
  missionView: MissionView;
  entranceInterviewDialogOpen: boolean;
  inBounds: boolean;
  currentWaypoint: Waypoint | undefined;

  targetCoordinate: Coordinate | undefined;
  coringAllowedState: CoringAllowedState;
  strictCoreEnforcement: boolean;
}

const topicsToSave = [
  rosEventKey(INBOUND_TOPICS.CONFIG_BIG_MOTOR),
  rosEventKey(INBOUND_TOPICS.CONFIG_BR_DEADBAND),
  rosEventKey(INBOUND_TOPICS.CONFIG_BR_MAX_POS),
  rosEventKey(INBOUND_TOPICS.CONFIG_BR_MIN_POS),
  rosEventKey(INBOUND_TOPICS.CONFIG_BRAKE_SAFETY_CHECK),
  rosEventKey(INBOUND_TOPICS.CONFIG_CARRIAGE_DOWN_SPEED),
  rosEventKey(INBOUND_TOPICS.CONFIG_CARRIAGE_UP_SPEED),
  rosEventKey(INBOUND_TOPICS.CONFIG_CDN_MAX),
  rosEventKey(INBOUND_TOPICS.CONFIG_CDN_MIN),
  rosEventKey(INBOUND_TOPICS.CONFIG_CORE_TIMEOUT),
  rosEventKey(INBOUND_TOPICS.CONFIG_CUP_MAX),
  rosEventKey(INBOUND_TOPICS.CONFIG_CUP_MIN),
  rosEventKey(INBOUND_TOPICS.CONFIG_DCC_MAX),
  rosEventKey(INBOUND_TOPICS.CONFIG_DCC_MIN),
  rosEventKey(INBOUND_TOPICS.CONFIG_DCW_MAX),
  rosEventKey(INBOUND_TOPICS.CONFIG_DCW_MIN),
  rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH),
  rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH_ARRIVAL_TARGET),
  rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH_OFFSET),
  rosEventKey(INBOUND_TOPICS.CONFIG_DWELL_AT_TOP_TIME),
  rosEventKey(INBOUND_TOPICS.CONFIG_DWELL_TIME),
  rosEventKey(INBOUND_TOPICS.CONFIG_IMPLEMENT_SELECTED),
  rosEventKey(INBOUND_TOPICS.CONFIG_MAX_SPEED),
  rosEventKey(INBOUND_TOPICS.CONFIG_OVERRIDE_DEPTH),
  rosEventKey(INBOUND_TOPICS.CONFIG_SPEED_SAFETY_CHECK),
  rosEventKey(INBOUND_TOPICS.CONFIG_TH_DEADBAND),
  rosEventKey(INBOUND_TOPICS.CONFIG_TH_MAX_POS),
  rosEventKey(INBOUND_TOPICS.CONFIG_TH_MIN_POS),
  rosEventKey(INBOUND_TOPICS.CONFIG_TIP_TO_GROUND),
];

const SAMPLE_SEND_TIMEOUT_MS = 1000;

class SamplingTask extends PureComponent<SamplingTaskProps, SamplingTaskState> {
  MAX_SAMPLES_PER_AUTOSAVE = 5;

  depthLockInitialized: boolean;
  drillDepthInitialized: boolean;
  setStateAsync: SetStateAsync;
  lastCompletedSampleSave: number;
  emptyEventBusCallback = () => {};

  sampleSelectionTimeout: NodeJS.Timeout;
  entranceInterviewDialogTimer: NodeJS.Timeout | undefined = undefined;
  closeTimeout: NodeJS.Timeout;
  position: RosPosition;

  currentOrLastSampleSender: NodeJS.Timeout;
  /**
   * The job whose shift the order overlay follows. Kept once a job has been
   * opened so that closing it does not widen the overlay back to the whole day.
   */
  lastMissionID = '';
  private _scheduledAutoSaves = new Set<number>();

  constructor(props: SamplingTaskProps) {
    super(props);

    this.state = {
      autoSync: JSON.parse(localStorage.getItem('autoSync') || (isMobile ? 'false' : 'true')) as boolean,
      controlRole: 'unknown',
      currentMissionChecksum: undefined,
      depthLocked: false,
      drillDepthDisplay: undefined,
      drillDepthRaw: undefined,
      drillDepthOffset: undefined,
      filledSamples: undefined,
      hmiVisible: JSON.parse(localStorage.getItem('hmiVisible') || 'false') as boolean,
      lastSyncTimestamp: undefined,
      loadingSchedule: false,
      missionDepth: undefined,
      navWarningDirections: '',
      navigationPopupVisible: false,
      growerNotificationPromptVisible: false,
      navigationJobInstanceId: 0,
      operatorNotes: '',
      operatorNotesDialogOpen: !JSON.parse(localStorage.getItem('notesClosed') || 'false'),
      outOfSync: false,
      robotMission: undefined,
      scannerActive: JSON.parse(localStorage.getItem('scannerActive') || 'false') as boolean,
      scheduleFeatures: [],
      scheduleItems: [],
      sampledItems: [],
      offlineItems: [],
      syncInProgress: false,
      totalSamples: undefined,
      trackingOverride: false,
      presentSample: undefined,
      closeSample: undefined,
      confirmFullscreenButton: false,
      robotNavControlState: 'Manual',
      soilInBucket: false,
      robotArmType: RobotArmType.NormalArm,
      disableBarcodeTracking: DisableBarcodeEnforcement.get(),
      robotState: RobotState['Unknown'],
      reasonSelectorOptions: undefined,
      manualMeasurementDialogOpen: false,
      manualMeasurementDialogParameters: null,
      boxToClose: undefined,
      boxPdf: undefined,
      activeBox: undefined, // active box unique id
      boxInstanceId: undefined, // active box instance id
      boxMissions: [], // { name: '', instanceId: ... }
      boxesNeedReprint: [], // { boxId: ..., boxInstanceId: ..., boxMissions: ... }
      printerConfig: PRINTER_SIZE_4_6,
      printURL: getPrintURLFromConfig(PRINTER_SIZE_4_6),
      allBoxes: [],
      boxPdfPreviewVisible: false,
      boxCloseTitle: '',
      currentMissionPhotos: [],
      missionView: (localStorage.getItem('missionView') as MissionView) || 'standard',
      entranceInterviewDialogOpen: false,
      inBounds: false,
      currentWaypoint: undefined,
      targetCoordinate: undefined,
      coringAllowedState: 'Good',
      strictCoreEnforcement: CoreCountEnforcementEnabled.get(),
    };

    this.syncMission = this.syncMission.bind(this);
    this.checkOutOfSync = this.checkOutOfSync.bind(this);
    this.updateRobotMission = this.updateRobotMission.bind(this);
    this.setWaypoint = this.setWaypoint.bind(this);
    this.setZoneWaypoint = this.setZoneWaypoint.bind(this);
    this.updateAutoSync = this.updateAutoSync.bind(this);
    this.loadMissionSchedule = this.loadMissionSchedule.bind(this);
    this.setStateAsync = setStateAsync.bind(this);
    this.toggleScanner = this.toggleScanner.bind(this);
    this.showNavMessage = this.showNavMessage.bind(this);
    this.loadSchedule = this.loadSchedule.bind(this);
    this.getSampleTotal = this.getSampleTotal.bind(this);
    this.openManualMeasurementDialog = this.openManualMeasurementDialog.bind(this);
    this.loadMissionData = this.loadMissionData.bind(this);
    this.updateCompletedSync = this.updateCompletedSync.bind(this);
    this.closeNotesDialog = this.closeNotesDialog.bind(this);
    this.toggleNotesDialog = this.toggleNotesDialog.bind(this);
    this.toggleHMIVisible = this.toggleHMIVisible.bind(this);
    this.checkForOperatorNotes = this.checkForOperatorNotes.bind(this);
    this.updateDepthLock = this.updateDepthLock.bind(this);
    this.updateDepthSetting = this.updateDepthSetting.bind(this);
    this.setDepth = this.setDepth.bind(this);
    this.checkDepthSync = this.checkDepthSync.bind(this);
    this.initializeSamplingParameters = this.initializeSamplingParameters.bind(this);
    this.toggleTrackingOverride = this.toggleTrackingOverride.bind(this);
    this.resetRobotState = this.resetRobotState.bind(this);
    this.updateRobotControlRole = this.updateRobotControlRole.bind(this);
    this.waypointResetAlert = this.waypointResetAlert.bind(this);
    this.waypointPublish = this.waypointPublish.bind(this);
    this.doSampleCountLogic = this.doSampleCountLogic.bind(this);
    this.resubmitAll = this.resubmitAll.bind(this);
    this.updateAutoManualState = this.updateAutoManualState.bind(this);
    this.soilInBucketChanged = this.soilInBucketChanged.bind(this);
    this.robotArmTypeMessageReceived = this.robotArmTypeMessageReceived.bind(this);
    this.isInBulkDensityMode = this.isInBulkDensityMode.bind(this);
    this.finishBoxExitInterview = this.finishBoxExitInterview.bind(this);
    this.closeBox = this.closeBox.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.handleCloseBox = this.handleCloseBox.bind(this);
    this.showBoxCheckin = this.showBoxCheckin.bind(this);
    this.handlePrinterSelect = this.handlePrinterSelect.bind(this);
    this.updateBoxData = this.updateBoxData.bind(this);
    this.updateBoxNeedsReprint = this.updateBoxNeedsReprint.bind(this);
    this.sendCurrentOrLastMissionSample = this.sendCurrentOrLastMissionSample.bind(this);
    this.showSkipReasonSelectorPopup = this.showSkipReasonSelectorPopup.bind(this);
    this.coreComplete = this.coreComplete.bind(this);
    this.dumpComplete = this.dumpComplete.bind(this);
    this.dumpCompleteMsgReceived = this.dumpCompleteMsgReceived.bind(this);
    this.handleRobotState = this.handleRobotState.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
    this.updateDepthOffsetSetting = this.updateDepthOffsetSetting.bind(this);
    this.clearEntranceInterviewTimer = this.clearEntranceInterviewTimer.bind(this);
    this.lastCompletedSampleSave = 0;

    this.updateStrictCoreEnforcement = this.updateStrictCoreEnforcement.bind(this);
  }

  async componentDidMount() {
    restartPeriodicDbSync(this.props.task);

    EventBus.on(MISSION_EVENTS.UPDATED, this.loadMissionData);
    EventBus.on(MISSION_EVENTS.UPDATED, this.initializeSamplingParameters);
    EventBus.on(MISSION_EVENTS.UPDATED, this.checkDepthSync);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.loadMissionData);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.checkForOperatorNotes);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.initializeSamplingParameters);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.checkDepthSync);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.clearEntranceInterviewTimer);
    EventBus.on(MISSION_EVENTS.CREATED_OR_DELETED, this.refreshScheduleFeatures);
    EventBus.on(BOX_EVENTS.ACTIVE_UPDATED, this.getSampleTotal);
    EventBus.on(CHANGE_EVENTS.SHOW_CHANGE_REASON_SELECTOR, this.showSkipReasonSelectorPopup);

    EventBus.on('ROSRESET', this.resetRobotState);
    EventBus.on('ROBOT_ROLE_UPDATED', this.updateRobotControlRole);

    onRobotMessage(INBOUND_TOPICS.ARM_CORE_COMPLETE, this.coreComplete);
    onRobotMessage(INBOUND_TOPICS.ARM_DUMP_COMPLETE, this.dumpCompleteMsgReceived);
    onRobotMessage(INBOUND_TOPICS.POSITION, this.updatePosition);
    onRobotMessage(INBOUND_TOPICS.STATUS_PHYSICAL_SOILINBUCKET, this.soilInBucketChanged, true);
    onRobotMessage(INBOUND_TOPICS.STATUS_LOGICAL_ARM_TYPE, this.robotArmTypeMessageReceived, true);
    onRobotMessage(hmiInboundTopic('butt_4', 'color'), this.updateAutoManualState, true);
    onRobotMessage(INBOUND_TOPICS.ROBOT_STATE, this.handleRobotState, true);

    onRobotMessage(INBOUND_TOPICS.CONFIG_OFFSET_X, this.updateOffsetX, true);
    onRobotMessage(INBOUND_TOPICS.CONFIG_OFFSET_Y, this.updateOffsetY, true);

    // TODO adding box events relatively early to try to get the box data to render the UI
    // properly
    EventBus.on(BOX_EVENTS.ACTIVE_UPDATED, this.updateBoxData);
    EventBus.on(BOX_EVENTS.SAMPLES_UPDATED, this.updateBoxData);
    EventBus.on(BOX_EVENTS.MOVED_SAMPLE, this.updateBoxNeedsReprint);
    EventBus.on(MISSION_EVENTS.UPDATED, this.updateBoxData);

    // EventBus.on('ROSMSG/status/logical/bulking', this.logicalStartBulking);
    await this.updateBoxData();
    this.updateBoxNeedsReprint();

    await this.loadSchedule();
    this.getSampleTotal();

    this.depthLockInitialized = false;
    this.drillDepthInitialized = false;

    BarcodeProcessorStateStore.set({ barcodeScanningPaused: false, boxScanningPaused: false });

    const mission = getCurrentMission();

    if (mission) {
      this.initializeSamplingParameters();

      const currentUser = getCurrentSession()?.getUser();
      const userRequiredToDoEntranceInterviews = currentUser && !currentUser.customer_boundary_recording;

      if (!mission.getJob()?.entrance_interview_complete && userRequiredToDoEntranceInterviews) {
        this.setState({ entranceInterviewDialogOpen: true });
      }

      // TODO we are doing this for now to ensure that the data gets "cached"
      // in the event bus and we can access it. Unfortunately, this means
      // the robot panel is also subscribing the duplicated topics, so ideally
      // we could subscribe at this level and pass it to the robot panel
      // but this works for now
      for (const topic of topicsToSave) {
        EventBus.on(topic, this.emptyEventBusCallback);
      }
    }

    EventBus.on(rosEventKey(INBOUND_TOPICS.CONFIG_OVERRIDE_DEPTH), this.updateDepthLock, true);
    EventBus.on(rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH), this.updateDepthSetting, true);
    EventBus.on(rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH_OFFSET), this.updateDepthOffsetSetting, true);

    await this.checkForOperatorNotes();

    this.setState({
      hmiVisible: JSON.parse(localStorage.getItem('hmiVisible') || 'false'),
      missionView: (localStorage.getItem('missionView') as MissionView) || 'standard',
    });

    if (SimulatorEnabledStorage.get()) {
      inProcessSimulator(this);
    }

    if (MobileHelperEnabled.get()) {
      // not awaiting this because it will then handle its own callbacks
      this.sendCurrentOrLastMissionSample();
    }
  }

  componentWillUnmount() {
    EventBus.remove(MISSION_EVENTS.UPDATED, this.loadMissionData);
    EventBus.remove(BOX_EVENTS.ACTIVE_UPDATED, this.getSampleTotal);
    EventBus.remove(MISSION_EVENTS.UPDATED, this.initializeSamplingParameters);
    EventBus.remove(MISSION_EVENTS.UPDATED, this.checkDepthSync);
    EventBus.remove(MISSION_EVENTS.CREATED_OR_DELETED, this.loadMissionData);
    EventBus.remove(MISSION_EVENTS.CREATED_OR_DELETED, this.checkForOperatorNotes);
    EventBus.remove(MISSION_EVENTS.CREATED_OR_DELETED, this.initializeSamplingParameters);
    EventBus.remove(MISSION_EVENTS.CREATED_OR_DELETED, this.checkDepthSync);
    EventBus.remove(MISSION_EVENTS.CREATED_OR_DELETED, this.refreshScheduleFeatures);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_SYNC), this.updateRobotMission);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_CUD_SYNC), this.updateRobotMission);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_SYNC_DONE), this.updateCompletedSync);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.CONFIG_OVERRIDE_DEPTH), this.updateDepthLock);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH), this.updateDepthSetting);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.CONFIG_DEPTH_OFFSET), this.updateDepthOffsetSetting);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT_RESET), this.waypointResetAlert);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT), this.waypointPublish);
    EventBus.remove('ROSRESET', this.resetRobotState);
    EventBus.remove('ROBOT_ROLE_UPDATED', this.updateRobotControlRole);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.ARM_CORE_COMPLETE), this.coreComplete);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.ARM_DUMP_COMPLETE), this.dumpCompleteMsgReceived);
    removeRobotMessageCallback('position', this.updatePosition);
    EventBus.remove(rosEventKey(hmiInboundTopic('butt_4', 'color')), this.updateAutoManualState);
    EventBus.remove(rosEventKey(INBOUND_TOPICS.STATUS_PHYSICAL_SOILINBUCKET), this.soilInBucketChanged);
    EventBus.remove('status/logical/arm_type', this.robotArmTypeMessageReceived);
    EventBus.remove(CHANGE_EVENTS.SHOW_CHANGE_REASON_SELECTOR, this.showSkipReasonSelectorPopup);
    // EventBus.remove('ROSMSG/status/logical/bulking', this.logicalStartBulking);

    EventBus.remove(rosEventKey(INBOUND_TOPICS.ROBOT_STATE), this.handleRobotState);

    removeRobotMessageCallback('config/offset_x', this.updateOffsetX);
    removeRobotMessageCallback('config/offset_y', this.updateOffsetY);

    for (const topic of topicsToSave) {
      EventBus.remove(topic, this.emptyEventBusCallback);
    }

    EventBus.remove(BOX_EVENTS.ACTIVE_UPDATED, this.updateBoxData);
    EventBus.remove(BOX_EVENTS.SAMPLES_UPDATED, this.updateBoxData);
    EventBus.remove(BOX_EVENTS.MOVED_SAMPLE, this.updateBoxNeedsReprint);
    EventBus.remove(MISSION_EVENTS.UPDATED, this.updateBoxData);

    clearTimeout(this.currentOrLastSampleSender);

    this.clearEntranceInterviewTimer();
  }

  updateStrictCoreEnforcement(newValue: boolean) {
    this.setState({ strictCoreEnforcement: newValue });
    CoreCountEnforcementEnabled.set(newValue);
  }

  clearEntranceInterviewTimer = () => {
    clearTimeout(this.entranceInterviewDialogTimer);
    this.entranceInterviewDialogTimer = undefined;
  };

  entranceInterviewStateLogic = async (prevState: SamplingTaskState) => {
    const session = getCurrentSession();

    if (session?.getUser()?.customer_boundary_recording) {
      return;
    }

    const mission = getCurrentMission();
    const entranceInterviewClosed = !this.state.entranceInterviewDialogOpen;
    const entranceInterviewJustClosed =
      entranceInterviewClosed && this.state.entranceInterviewDialogOpen !== prevState.entranceInterviewDialogOpen;

    const entranceInterviewComplete = mission?.getJob()?.entrance_interview_complete;
    let timerAlreadySet = !!this.entranceInterviewDialogTimer;

    if (entranceInterviewJustClosed && !entranceInterviewComplete && !timerAlreadySet) {
      this.entranceInterviewDialogTimer = setTimeout(() => {
        // This intentionally uses the getCurrentMission() variable inside of the callback instead
        // of `mission` above because otherwise the mission might have been closed and we wouldn't know
        // that unless we check here
        // additionally, this could also come up if the user has opened a new mission
        // either way, this logic might need some work
        if (getCurrentMission()) {
          this.setState({ entranceInterviewDialogOpen: true });
        }

        this.clearEntranceInterviewTimer();
      }, 5 * _MS_PER_MIN);
      timerAlreadySet = true;
    }

    const robotConnected = this.props.connectionStatus === 'connected';

    if (robotConnected && !timerAlreadySet) {
      if (mission) {
        const entranceInterviewComplete = mission.getJob()?.entrance_interview_complete;

        if (!entranceInterviewComplete && this.props.connectionStatus === 'connected') {
          this.setState({ entranceInterviewDialogOpen: true });
        }
      }
    }
  };

  async componentDidUpdate(prevProps: SamplingTaskProps, prevState: SamplingTaskState) {
    localStorage.setItem('missionView', this.state.missionView);

    //console.log(`SamplingTask:componentDidUpdate`, this.state.sampleToNavigateTo, this.state.robotNavControlState);
    if (this.props.connectionStatus === 'connected') {
      if (prevProps.connectionStatus !== this.props.connectionStatus) {
        EventBus.on(rosEventKey(INBOUND_TOPICS.MISSION_SYNC_DONE), this.updateCompletedSync, true);
        EventBus.on(rosEventKey(INBOUND_TOPICS.MISSION_CUD_SYNC), this.updateRobotMission, true);
        EventBus.on(rosEventKey(INBOUND_TOPICS.MISSION_SYNC), this.updateRobotMission, true);
        EventBus.on(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT_RESET), this.waypointResetAlert);
        EventBus.on(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT), this.waypointPublish);
        await this.checkOutOfSync();
      }
    }

    await this.entranceInterviewStateLogic(prevState);

    if (this.props.connectionStatus === 'disconnected' && prevProps.connectionStatus === 'connected') {
      EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_SYNC), this.updateRobotMission);
      EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_CUD_SYNC), this.updateRobotMission);
      EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_SYNC_DONE), this.updateCompletedSync);
      EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT_RESET), this.waypointResetAlert);
      EventBus.remove(rosEventKey(INBOUND_TOPICS.MISSION_WAYPOINT), this.waypointPublish);
      this.clearMissionInfo();
    }

    if (this.state.filledSamples !== prevState.filledSamples) {
      await this.doSampleCountLogic();
    }

    // detect falling edge of soil in bucket
    // TODO disabled as of 2024-09-04 in favor of dump_complete message
    // if (!this.state.soilInBucket && prevState.soilInBucket) {
    //   await this.dumpComplete(Date.now());
    // }
  }

  updateOffsetX = (robotMessage: RobotNumberMessage) => {
    RobotArmOffsetX.set(robotMessage.msg.data / 1000);
  };

  updateOffsetY = (robotMessage: RobotNumberMessage) => {
    RobotArmOffsetY.set(robotMessage.msg.data / 1000);
  };

  async sendCurrentOrLastMissionSample() {
    try {
      const session = getCurrentSession();
      const mission = getCurrentMission();

      // don't let helper send mission ID
      // TODO not sure if this is problematic or not...
      // if the operator is sampling on their phone, this
      // wouldn't get called, but if they're sampling on
      // their phone, then this would be irrelevant
      // The better design would be
      if (isMobile) {
        return;
      }

      if (this.state.controlRole === 'control') {
        let jobId: string | undefined;
        let sampleId: string | undefined;

        if (mission) {
          jobId = mission.job_id;
          const currentSample = session?.getSample();

          if (currentSample) {
            // get sample
            sampleId = currentSample.sample_id;
          } else if (this.state.presentSample) {
            sampleId = this.state.presentSample.sample_id;
          } else {
            sampleId = mission.getLastScannedSampleId();
          }
        }

        // console.log(`${new Date()} Sending current_job_sample to ${session?.robot_hostname} with sample_id: ${sampleId} and job_id: ${jobId}`)
        const helperData = {
          data: {
            sample_id: sampleId || '',
            job_id: jobId || '',
          },
        };
        dispatchRosMsgPeer({
          hostname: session?.robot_hostname || '',
          msg: helperData,
          tag: Math.round(Math.random() * 100000).toString(),
          topic: 'current_job_sample',
          broadcast: 'send_to_others',
        });
        await proxyPublishHelperData(helperData);

        const photos = jobId ? await proxyGetFiles(jobId) : [];
        this.setState({ currentMissionPhotos: photos });
      }
    } catch (err) {
      console.error('Could not send current job sample', err);
    }

    this.currentOrLastSampleSender = setTimeout(async () => {
      await this.sendCurrentOrLastMissionSample();
    }, SAMPLE_SEND_TIMEOUT_MS);
  }

  /**
   * Generates a pdf from the box data and updates state with the data url to display to the user
   * @param {object} box Data class instance of the SampleBox that will be displayed
   */
  async showBoxCheckin(box: SampleBox) {
    try {
      const boxPdf = await generateBoxCheckin(box, this.state.printerConfig);
      this.setState({
        boxPdfPreviewVisible: true,
        boxPdf,
        boxCloseTitle: box.ReprintSession_id ? 'Reprint Box' : 'Close Box',
      });

      if (box.needsUpdated) {
        const currentMission = getCurrentMission();
        const noCurrentMission = !currentMission;
        const currentMissionInBox = currentMission && box.getSampleBoxMissions().includes(currentMission);
        const currentMissionNotInBox = !currentMissionInBox;

        if (noCurrentMission || currentMissionNotInBox) {
          // upload box data to S3
          // TODO maybe need timeout if no internet?
          const uploadSucceeded = await box.upload();

          if (!uploadSucceeded) {
            alertError('Could not upload box data to S3');
          }
        }
      }
    } catch (err) {
      console.error('Could not export PDF', err);
      alertWarn('Could not export PDF');
    }
  }

  /**
   * Asks for user confirmation to close/dispose of the box
   * @param {object} box Data class instance of a SampleBox that could be closed
   */
  async handleNoSamples(box: SampleBox) {
    const confirm = await alertConfirm('This box is empty! Do you wish to close it?', 'empty-box-close');

    if (confirm) {
      // Check that the box is still empty before closing - could have changed while waiting for user input.
      // This actually happened for Andrew Crane on 2025-11-03. The popup appeared, then the sample was scanned,
      // then he confirmed the popup, and the box closed with a sample in it.
      const boxToCloseSamples = box.getSamples();
      const boxHasNoSamples = !boxToCloseSamples || !boxToCloseSamples?.length;

      if (boxHasNoSamples) {
        await this.closeBox(box, true);
        await logger.log('HANDLE_NO_SAMPLES', 'user confirmed empty box close');
      } else {
        alertWarn('Box is no longer empty, opening box check-in dialog.');
        await this.showBoxCheckin(box);
        this.setState({ boxToClose: box });
        await logger.log('HANDLE_NO_SAMPLES', 'box no longer empty upon close confirmation');
      }
    } else {
      await logger.log('HANDLE_NO_SAMPLES', 'user denied empty box close');
    }
  }

  /**
   * Handle the close box button press.
   *
   * Case 1: If we have an open box but NO samples, then simply provide a
   *         confirmation popup to just close the empty box
   *
   * Case 2: Else if we have an open box that does have samples, show the
   *         box close dialog
   *
   * Case 3: Else if we DON'T have an open box, but we do have boxes that need
   *         reprinted, then get the the box from the top of the box reprint
   *         array and show the checkin dialog
   */
  async handleCloseBox(box?: SampleBox) {
    let boxToClose = box || SampleBox.getCurrentBox();
    const openBoxes = SampleBox.getOpenBoxes();

    if (openBoxes.length > 1 && !box) {
      const boxUid = await alertFullScreen(
        'Which box?',
        `Please select the box you are closing`,
        openBoxes.map((box) => box.short_uid),
      );
      boxToClose = openBoxes.find((box) => box.short_uid === boxUid);
    }

    // MISSIONCONTROL-MD
    // SamplingTask.handleCloseBox(components/SamplingTask)
    // TypeError: t.getSamples is not a function

    const boxToCloseSamples = boxToClose?.getSamples();
    const boxHasNoSamples = !boxToCloseSamples || !boxToCloseSamples?.length;

    if (boxToClose && boxHasNoSamples) {
      await this.handleNoSamples(boxToClose);
    } else if (boxToClose) {
      await this.showBoxCheckin(boxToClose);
      this.setState({ boxToClose });
    } else if (!boxToClose && this.state.boxesNeedReprint.length) {
      const boxReprintId = this.state.boxesNeedReprint[this.state.boxesNeedReprint.length - 1].instanceId;
      const boxReprint = SampleBox.get(boxReprintId);

      if (!boxReprint) {
        throw new Error(`Could not find box with instance id ${boxReprintId}`);
      }

      await this.showBoxCheckin(boxReprint);
      this.setState({ boxToClose: boxReprint });
    }
  }

  // logicalStartBulking = () => {
  //   logger.log('LOGICAL_START_BULKING', `Logical start bulking ${JSON.stringify(this.position)} ${this.state.presentSample?.sample_id}`);
  // }

  showSkipReasonSelectorPopup(changePopupOptions: ShowChangeTypeSelectorPopup) {
    this.setState({ reasonSelectorOptions: changePopupOptions });
  }

  handleRobotState({ hostname, msg }: { hostname: string; msg: { data: number } }) {
    const session = getCurrentSession();

    if (session?.robot_hostname === hostname) {
      const robotState = msg.data;

      if (robotState !== this.state.robotState.valueOf()) {
        this.setState({ robotState });
      }
    }
  }

  // this should happen in auto and manual mode
  async soilInBucketChanged({ hostname, msg }: { hostname: string; msg: { data: boolean } }) {
    const session = getCurrentSession();

    if (session?.robot_hostname === hostname) {
      const soilInBucket = msg.data === true;

      if (soilInBucket !== this.state.soilInBucket) {
        this.setState({ soilInBucket });
      }
    }
  }

  async robotArmTypeMessageReceived(robotMessage: RobotNumberMessage) {
    const session = getCurrentSession();

    if (session?.robot_hostname !== robotMessage.hostname) {
      return;
    }

    const robotArmType = robotMessage.msg.data;

    if (robotArmType !== this.state.robotArmType) {
      this.setState({ robotArmType });
    }
  }

  async updateAutoManualState({ hostname, msg }: { hostname: string; msg: { data: number } }) {
    const session = getCurrentSession();

    if (session?.robot_hostname === hostname) {
      this.setState({ robotNavControlState: msg.data === COLOR['GREEN'].valueOf() ? 'Auto' : 'Manual' });
    }
  }

  async coreComplete(event: { hostname: string; msg: CoreMsg }) {
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    const coreCompletionHandler = new CoreCompletion(
      mission,
      this.position,
      this.state.presentSample,
      this.dumpComplete,
      (presentSample) => {
        if (!presentSample.isPending()) {
          saveDbToRecoveryServer(DB_SAVE_REASONS.SAMPLE_COMPLETED).catch((err) => {
            console.error('Failed to save DB to recovery server after sample completed', err);
          });
        }
      },
      this.openManualMeasurementDialog,
    );

    await coreCompletionHandler.handle(event);
  }

  async dumpCompleteMsgReceived(event: { hostname: string; msg: DumpCompleteMsg }) {
    await this.dumpComplete();
  }

  async dumpComplete(this: SamplingTask) {
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    const now = Date.now();

    const coresInBucketIncludingBdCores = mission.getSoilCoresInBucket(false);

    const recentDump = mission.getLastDump();
    const dumpEvent = SoilDumpEvent.createDump({
      Mission_id: mission.instance_id,
      guid: uuidv4(),
      timestamp: now,
      lat: this.position.x,
      lon: this.position.y,
      heading: this.position.z,
      PreviousDump_id: recentDump?.instance_id,
    });

    for (const core of coresInBucketIncludingBdCores) {
      core.SoilDumpEvent_id = dumpEvent.instance_id;
    }

    const sample = dumpEvent.getSample();

    if (!sample) {
      if (!coresInBucketIncludingBdCores.length) {
        alertWarn('No cores in bucket');

        return;
      }

      if (coresInBucketIncludingBdCores[0].test_core_Mission_id) {
        alertInfo(`Dumped ${coresInBucketIncludingBdCores.length} test cores`);

        return;
      }

      alertWarn("We noticed a soil dump, but don't know what it belonged to");

      return;
    }

    EventBus.dispatch(MAP_EVENTS.DUMP_SUCCESS, sample.sample_id);

    const { pulledCoresReady, requiredPulledCoresNumber, pulledCoresNumber } = sample.hasPulledCoresReady();

    if (this.state.strictCoreEnforcement && !pulledCoresReady) {
      errorTone();
      alertError(
        `Sample ${sample.sample_id} does not have the right number of cores, need ${requiredPulledCoresNumber}, pulled ${pulledCoresNumber}`,
      );

      return;
    }

    if (BarcodeSelectionModeStore.get() !== 'Automatic') {
      alertWarn('Dump recieved but barcode advancement mode is not set to automatic');

      return;
    }

    alertInfo(`Sample ${sample.sample_id} dumped and ready for scanning`);

    // TODO this is where we could command a dump
    await setSampleSelected({ timestamp: new Date(), sampleInstanceId: sample.instance_id! });
  }

  updateInBounds(coordinate: Coordinate) {
    const mission = getCurrentMission();

    // Check if in bounds
    let boundary: Zone | undefined;

    // Trying and catching for the case when the boundary is deleted.
    try {
      boundary = mission?.getBoundary();
    } catch (e) {}

    const inBounds = boundary?.contains(coordinate[0], coordinate[1]) || false;

    if (inBounds !== this.state.inBounds) {
      this.setState({ inBounds });
    }
  }

  isInBulkDensityMode(): boolean {
    return this.state.robotArmType === RobotArmType.BulkArm;
  }

  async updatePosition({ hostname, msg }: { hostname: string; msg: RosPosition }) {
    if (!canHandlePositionUpdate(hostname)) {
      return;
    }
    // const start = performance.now();

    // We are explicitly NOT setting state here for this position value, otherwise we would cause too many re-renders to happen
    // in fact, the "close core" logic should likely happen in a lower level component to avoid the possibility of this logic
    // causing full re-renders when not necessary
    this.position = msg;

    const origin = calculateOrigin(msg);

    this.updateInBounds(origin);

    const sampleUpdates = calculateSampleUpdates(
      origin,
      this.state.currentWaypoint,
      this.state.robotNavControlState,
      this.state.soilInBucket,
      this.state.closeSample,
      this.state.presentSample,
      this.state.targetCoordinate,
      this.isInBulkDensityMode(),
      this.state.coringAllowedState,
      this.state.strictCoreEnforcement,
    );

    if (sampleUpdates) {
      const { presentSample, closeSample, targetCoordinate, coringAllowedState } = sampleUpdates;
      this.setState({ presentSample, closeSample, targetCoordinate, coringAllowedState });
    }

    // console.log(`updatePosition took ${(performance.now() - start).toFixed(0)} ms`);
  }

  clearMissionInfo() {
    this.setState({
      robotMission: undefined,
      lastSyncTimestamp: undefined,
    });
  }

  async updateRobotControlRole(role: RobotControlRole) {
    this.setState({
      controlRole: role,
    });
  }

  async waypointResetAlert({ hostname, msg }: { hostname: string; msg: any }) {
    const session = getCurrentSession();

    if (session?.robot_hostname === hostname) {
      const robotState = msg.data;

      if (robotState !== 0) {
        alertInfo('Target waypoint was reset! Ensure it is correct before hitting go!');
      }
    }
  }

  async waypointPublish({ hostname, msg }: { hostname: string; msg: { data: number } }) {
    const session = getCurrentSession();

    if (session?.robot_hostname !== hostname) {
      return;
    }

    const currentWaypointIndex = msg.data;
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    const waypoint = mission.getWaypoints().find((waypoint) => waypoint.waypoint_number === currentWaypointIndex);

    if (!waypoint) {
      return;
    }

    if (waypoint.waypoint_number !== this.state.currentWaypoint?.waypoint_number) {
      this.setState({ currentWaypoint: waypoint });
    }

    // const sample = waypoint.getCorePoint()?.getSoilCore()?.getSample();
    // if (!sample) {
    //   return;
    // }

    // const coordsFormatted = convertProjection4329([waypoint.lon, waypoint.lat]);
    // if (JSON.stringify(coordsFormatted) !== JSON.stringify(this.state.currentWaypoint)) {
    //   this.setState({ currentWaypoint: coordsFormatted });
    // }
  }

  // TODO should we really be just resetting these values here?
  resetRobotState() {
    this.setState({ drillDepthDisplay: undefined, drillDepthRaw: undefined, depthLocked: false });
  }

  async resubmitAll() {
    // get offline recovery files that are relevant in our list

    for (const offlineJob of this.state.offlineItems) {
      // get offline recovery file from recovery server based on job id
      const recoveryFile = await getRecoveryFile({ search: `OFFLINE_*${offlineJob.id}`, backIndex: 0 });

      if (recoveryFile) {
        // unzip the recovery file
        const { filename, content } = await textToZip(
          await getJobKmlFromZip({ file: recoveryFile, jobID: offlineJob.id }),
        );

        // upload to S3
        const checksum = await S3.upload(filename, content, content.type, { bucket: 'missionuploads' });

        if (!checksum) {
          alertError('Error uploading recovery file to S3');

          return;
        }
      }
    }
  }

  async checkForOperatorNotes() {
    const mission = getCurrentMission();

    if (mission) {
      const job = LocalAtRecord.getRecord('Jobs', mission.job_id || '');
      this.setState({
        operatorNotesDialogOpen: true,
        operatorNotes: (job?.get('Instructions for Field #ops') as string | undefined) || '',
      });
    } else {
      this.setState({
        operatorNotesDialogOpen: false,
        operatorNotes: '',
      });
    }
  }

  closeNotesDialog() {
    this.setState({ operatorNotesDialogOpen: false });
    localStorage.setItem('notesClosed', 'true');
  }

  toggleNotesDialog() {
    localStorage.setItem('notesClosed', this.state.operatorNotesDialogOpen.toString());
    this.setState({ operatorNotesDialogOpen: !this.state.operatorNotesDialogOpen });
  }

  toggleHMIVisible() {
    this.setState({ hmiVisible: !this.state.hmiVisible });
    localStorage.setItem('hmiVisible', (!this.state.hmiVisible).toString());
  }

  async updateCompletedSync({ hostname, msg }: { hostname: string; msg: { data: string } }) {
    const session = getCurrentSession();

    if (session?.robot_hostname === hostname) {
      this.setState({ currentMissionChecksum: msg.data });
    }

    await this.checkOutOfSync(msg.data);
  }

  async loadMissionData(missionData: CreatedOrDeletedParams) {
    // TODO moving samples causes this to reload, which we don't want to do, so we need to find
    // another way that we can "reset" upon a mission load?
    //await setSampleSelected(undefined);
    this.getSampleTotal();

    if (this.props.connectionStatus === 'connected') {
      await this.checkOutOfSync();
    }

    const mission = getCurrentMission();

    if (MissionEventStore.get().missionId !== mission?.job_id) {
      this.filterScheduleFeaturesAfterMissionUpload(missionData);

      MissionEventStore.reset();

      // If we're loading a new mission - make sure to set it here.
      if (mission?.job_id) {
        MissionEventStore.set({
          missionId: mission.job_id,
        });
      }

      this.updateStrictCoreEnforcement(true);

      MapNearbyAutoZoomEnabled.set(mission?.getJob()?.auto_zoom_near_sample || false);
    }
  }

  private filterScheduleFeaturesAfterMissionUpload(missionData: CreatedOrDeletedParams) {
    if (!missionData) {
      return;
    }

    const { deletedRogoJobId } = missionData;

    if (!deletedRogoJobId) {
      return;
    }

    this.setState((prevState: Readonly<SamplingTaskState>) => ({
      ...prevState,
      scheduleFeatures: prevState.scheduleFeatures.filter((feat) => !isFeatureRelatedToDeletedJob(feat)),
    }));

    function isFeatureRelatedToDeletedJob(feat: ScheduleFeature): unknown {
      return feat.properties && feat.properties['Rogo Job ID'] && feat.properties['Rogo Job ID'] === deletedRogoJobId;
    }
  }

  openManualMeasurementDialog(manualMeasurementDialogParameters: ManualMeasurementDialogParameters) {
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    this.setState({
      manualMeasurementDialogOpen: true,
      manualMeasurementDialogParameters: manualMeasurementDialogParameters,
    });
  }

  getSampleTotal() {
    const mission = getCurrentMission();

    if (!mission) {
      this.setState({ totalSamples: undefined, filledSamples: undefined });

      return;
    }

    const samples = mission.getAllSamples(false);
    const total = samples.length;
    const filled = samples.filter(
      (sample) => Boolean(sample.bag_id) && isBarcodeValidBag(sample.bag_id || '', sample.getBarcodeRegex()),
    ).length;

    this.setState({ totalSamples: total, filledSamples: filled });
  }

  async doSampleCountLogic() {
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    // Originally, this interval calculation was a bit more advanced and would scale based
    // on the size of the field. However, once the number of robot resets was improved, we decided
    // to less this to just happen every 5 samples
    //const interval = Math.min(Math.ceil(this.state.totalSamples / 40), this.MAX_SAMPLES_PER_AUTOSAVE);

    // SVH 3/8/2023: Making this 1 for now to save a recovery file every sample...
    // this has a risk of generating a LOT of recovery files, so we may need to come
    // up with a better auto-purge solution... but for now with the recovery server,
    // this is a good option
    const interval = BigFieldMode.get() ? 5 : 1;

    // if a small number, just update every sample
    // with this math (ceil(division)),
    // 1-50 samples = download every sample
    // 51-100 samples = download every 2 samples
    // 101-150   = 3
    // 151-200   = 4
    // 201-250   = 5
    // 251-300   = 6
    // 301-350   = 7
    // 351-400   = 8
    // ...

    const { filledSamples, totalSamples } = this.state;

    if (filledSamples === 1) {
      // if first filled sample...
      // TODO LOGGING store robot settings and log to job
      // console.log(`FIRST SAMPLE FILLED!`);
      const data: { [topic: string]: any } = {};

      for (const topic of topicsToSave) {
        const recent = EventBus.recent(topic);
        // console.log(`topic: ${topic}, recent.detail: ${JSON.stringify(recent?.detail)}`);
        data[topic] = recent?.detail?.msg?.data;
      }

      mission.settings_start = JSON.stringify(data);
    } else if (filledSamples === totalSamples) {
      // TODO LOGGING store robot settings and log to job
      const data: { [topic: string]: any } = {};

      for (const topic of topicsToSave) {
        const recent = EventBus.recent(topic);
        data[topic] = recent?.detail?.msg?.data;
      }

      mission.settings_end = JSON.stringify(data);
    }

    // only auto save if we have a sample AND this is a save interval

    if (filledSamples && filledSamples % interval === 0) {
      // Serg 2025-10-17: Make sure we're not calling it twice for the same number of filled samples.
      // Which used to be the case because doSampleCountLogic was called twice in an instant
      // and recovery files had the same name including the timestamp in seconds.
      // We first thought that was happenning only in DEV mode because of
      // React.StricMode behavior but then it happened on PROD.
      // The root cause: receiving several BOX_EVENTS.ACTIVE_UPDATED events and as a result
      // this.getSampleTotal is called multiple times and so does
      // this.setState({ totalSamples: total, filledSamples: filled });
      // where "filled" is different in the first call and in the second.
      // So, adding this check here to prevent this.

      if (!this._scheduledAutoSaves.has(filledSamples)) {
        this._scheduledAutoSaves.add(filledSamples);

        setTimeout(async () => {
          await saveRecoveryZip(mission, { tag: 'auto' });
          this._scheduledAutoSaves.delete(filledSamples);
        }, 10000);
      }
    }
  }

  /**
   * Toggles the sample scanner
   */
  toggleScanner() {
    localStorage.setItem('scannerActive', (!this.state.scannerActive).toString());
    this.setState({ scannerActive: !this.state.scannerActive });
  }

  async updateAutoSync(autoSync: boolean) {
    localStorage.setItem('autoSync', autoSync.toString());
    await this.setStateAsync({ autoSync });
    await this.checkOutOfSync();
  }

  checkDepthSync() {
    if (!this.drillDepthInitialized) {
      logger.logPeriodic('DEPTH_SYNC - Drill depth not initialized');

      return;
    }

    if (!this.depthLockInitialized) {
      logger.logPeriodic('DEPTH_SYNC - Depth lock not initialized');

      return;
    }

    if (this.state.controlRole !== 'control') {
      logger.logPeriodic('DEPTH_SYNC - Not in control');

      return;
    }

    const mission = getCurrentMission();

    if (!mission) {
      // we won't log this situation becauase it's quite common and not a concern
      logger.logPeriodic('DEPTH_SYNC - No mission', null, MS_PER_HOUR);

      return;
    }

    const missionDepth = mission.getPrimarySpec()?.end_depth || 0;

    if (!missionDepth) {
      logger.logPeriodic('DEPTH_SYNC - No mission depth specified or set to 0');
      alertWarn('No mission depth specified or set to 0');

      return;
    }

    if (this.state.depthLocked) {
      logger.logPeriodic('DEPTH_SYNC - Depth is locked');

      return;
    }

    let conversion = Math.round(Math.abs(missionDepth) * 25.4);

    if (missionDepth < 0) {
      conversion = conversion * -1;
    }

    if (conversion === this.state.drillDepthRaw) {
      logger.logPeriodic('DEPTH_SYNC - Drill depth from mission matches current depth');

      // alertSuccess('Drill depth from mission matches current depth');
      return;
    }

    this.setDepth(missionDepth);
  }

  resetRobotSettingsAndLockAccessLevel() {
    const session = getCurrentSession();

    if (!session) {
      return;
    }

    // VISIBILIY RESET. If we are not locked, lock for this mission
    if (this.props.accessLevel !== 'Locked') {
      // this actually LOWERS permission if we're already not locked
      this.props.elevatePermissions();
    }

    // RESET AUTO SYNC

    const offset = 0;
    dispatchRosMsgPub({
      hostname: session?.robot_hostname,
      msg: { data: offset },
      topic: OUTBOUND_TOPICS.CONFIG_SET_DEPTH_OFFSET,
      tag: this.constructor.name,
    });

    // TODO disabling for now, will revisit at a future date.
    // // these are daily?
    // const check = false;
    // dispatchRosMsgPub({
    //   topic: 'config/set_brake_safety_check',
    //   hostname: session?.robot_hostname,
    //   msg: { data: check },
    //   tag: this.constructor.name,
    // });

    // dispatchRosMsgPub({
    //   topic: 'config/set_speed_safety_check',
    //   hostname: session?.robot_hostname,
    //   msg: { data: check },
    //   tag: this.constructor.name,
    // });

    // const override = false;
    // dispatchRosMsgPub({
    //   hostname: session?.robot_hostname,
    //   msg: { data: override },
    //   topic: 'config/set_override_depth',
    //   tag: this.constructor.name
    // });
  }

  initializeSamplingParameters() {
    const mission = getCurrentMission();

    if (mission) {
      const spec = mission.getPrimarySpec();

      if (spec) {
        this.setState({
          missionDepth: spec.end_depth || 0,
        });
      }
    } else {
      this.setState({ missionDepth: undefined });
    }
  }

  updateDepthLock(event: any) {
    const session = getCurrentSession();
    const { hostname, msg } = event;

    if (hostname === session?.robot_hostname) {
      this.setState({
        depthLocked: msg.data,
      });

      this.depthLockInitialized = true;
      // logger.log('DEPTH_SYNC', 'Update Depth Lock');
      this.checkDepthSync();
    }
  }

  updateDepthSetting(event: { hostname: string; msg: { data: number } }) {
    const session = getCurrentSession();
    const { hostname, msg } = event;

    if (hostname === session?.robot_hostname) {
      const drillDepth = roundToIncrement(Math.abs(msg.data / MM_PER_INCH), 0.1);
      this.setState({
        drillDepthDisplay: drillDepth,
        drillDepthRaw: msg.data,
      });
      this.drillDepthInitialized = true;
      // logger.log('DEPTH_SYNC', 'Update Depth Setting');
      this.checkDepthSync();
    }
  }

  updateDepthOffsetSetting(event: { hostname: string; msg: { data: number } }) {
    const session = getCurrentSession();
    const { hostname, msg } = event;

    if (hostname === session?.robot_hostname) {
      const offset = msg.data;
      const drillDepthOffset = roundToIncrement(Math.abs(offset) / MM_PER_INCH, 0.125) * -Math.sign(offset);
      this.setState({
        drillDepthOffset,
      });
      // logger.log('DEPTH_SYNC', 'Update Depth Offset Setting');
      this.checkDepthSync();
    }
  }

  setDepth(depth: number) {
    const session = getCurrentSession();
    let conversion = Math.round(Math.abs(depth) * 25.4);

    if (depth < 0) {
      conversion = conversion * -1;
    }

    dispatchRosMsgPub({
      hostname: session?.robot_hostname || '',
      msg: { data: conversion },
      topic: OUTBOUND_TOPICS.CONFIG_SET_DEPTH,
      tag: this.constructor.name,
      expectationParams: {
        expectedTopic: 'config/depth',
        messages: {
          success: `Successfully set depth from ${this.state.drillDepthDisplay} to ${depth}!`,
          error: `Failed to set depth from ${this.state.drillDepthDisplay} to ${depth}!`,
        },
        doneCallback: (received: boolean, dataCorrect: boolean) => {
          if (!received || !dataCorrect) {
            errorTone();
            alertInfo('Set depth in HMI!');
          }
        },
      },
    });
  }

  syncMission() {
    const mission = getCurrentMission();
    const session = getCurrentSession();

    if (!mission) {
      this.setState({ syncInProgress: false });
      alertError('No mission loaded');

      return;
    }

    if (!this.state.outOfSync || this.state.syncInProgress) {
      return;
    }

    // package the mission
    const missionRos = mission.to_ros_msg();

    if (!missionRos) {
      this.setState({ syncInProgress: false });
      alertError('Failed to package mission');

      return;
    }

    // send mission (always cud_sync — mission/sync is deprecated)
    dispatchRosMsgPub({
      hostname: session?.robot_hostname || '',
      msg: missionRos,
      topic: OUTBOUND_TOPICS.MISSION_CUD_SYNC,
      compress: true,
      tag: this.constructor.name,
      expectationParams: {
        doneCallback: async (received: boolean, dataCorrect: boolean) => {
          this.setState({ syncInProgress: false });

          if (!received || !dataCorrect) {
            await this.checkOutOfSync();
          }
        },
        messages: {
          success: 'Mission successfully synced!',
          error: 'Mission failed to sync',
        },
        expectedTopic: 'mission/sync_done',
        expectedValue: { data: mission.nav_checksum },
        expectedTimeout: 15000,
      },
    });

    // set sync in progress
    this.setState({ syncInProgress: true });
  }

  async checkOutOfSync(checksum?: string) {
    const mission = getCurrentMission();

    if (!checksum) {
      checksum = this.state.currentMissionChecksum;
    }

    if (mission && this.props.connectionStatus === 'connected') {
      const outOfSync = !this.state.robotMission || mission.nav_checksum !== checksum;

      await this.setStateAsync({ outOfSync });

      if (this.state.autoSync && outOfSync && !this.state.syncInProgress && this.state.controlRole === 'control') {
        this.syncMission();
      }
    }
  }

  updateRobotMission({ hostname, msg }: { hostname: string; msg: RosMissionMsg }) {
    const session = getCurrentSession();

    if (msg && session?.robot_hostname === hostname && msg.header.frame_id === 'map') {
      if (!this.state.robotMission || !!(this.state.robotMission.nav_checksum !== msg.nav_checksum)) {
        console.log(`!!!! setting robot mission`);
        this.setState({
          robotMission: msg,
          lastSyncTimestamp: new Date(msg.header.stamp ? msg.header.stamp.secs * 1000 : Date.now()).toLocaleString(),
        });
      }
    }
  }

  async setWaypoint(
    startAt: StartAt,
    sampleInput: string | null,
    targetWaypointNumber: string | null,
    tag: string,
    doneCallback: () => void,
    coordinates?: Coordinate,
  ) {
    console.log(
      `Setting Waypoint: , Start At: ${startAt}, Sample Input: ${sampleInput}, Target Waypoint: ${targetWaypointNumber}, Tag: ${tag}, Coordinates: ${coordinates}`,
    );
    const mission = getCurrentMission();
    const isZoneMission = mission?.is_zone_mission() || false;
    await logger.log('SET_WAYPOINT', { startAt, sampleInput, targetWaypointNumber });

    if (!this.state.robotMission) {
      alertWarn('No robot mission found');
      doneCallback();

      return;
    }

    const waypointNumber = calculateWaypointNumber({
      startAt,
      sampleInput,
      targetWaypointNumber,
      coordinates,
      waypoints: this.state.robotMission.waypoints,
      isZoneMission,
    });

    if (waypointNumber == null) {
      alertWarn(
        `SET_WAYPOINT - waypoint number is null, startAt ${startAt}, sampleInput ${sampleInput}, targetWaypointNumber ${targetWaypointNumber}`,
      );
      doneCallback();

      return;
    }

    const shouldContinue = await handleResampleCheck(mission, waypointNumber);

    if (!shouldContinue) {
      doneCallback();

      return;
    }

    const target =
      startAt === StartAt.GoToStart
        ? 'first sample'
        : startAt === StartAt.GoToEnd
          ? 'last sample'
          : sampleInput
            ? `sample ${sampleInput}`
            : `target waypoint number ${targetWaypointNumber}`;

    const session = getCurrentSession();
    dispatchRosMsgPub({
      hostname: session?.robot_hostname ?? '',
      msg: { data: waypointNumber },
      topic: OUTBOUND_TOPICS.MISSION_SET_WAYPOINT,
      tag,
      expectationParams: {
        expectedTopic: 'mission/waypoint',
        expectedTimeout: 90_000, // navigation to waypoint can take up to 90s
        messages: {
          success: `Successfully set waypoint ${waypointNumber} to ${target}!`,
          error: `Failed to set waypoint ${waypointNumber} to ${target}!`,
        },
        doneCallback,
      },
    });
  }

  async setZoneWaypoint(
    zoneName: string | null,
    sampleId: string | null,
    tag: string,
    doneCallback: () => void,
    coordinates?: Coordinate,
  ) {
    const mission = getCurrentMission();
    const allZones = mission?.getZones() ?? [];

    if (sampleId) {
      await this.setWaypoint(StartAt.GoToSample, sampleId, null, tag, doneCallback, coordinates);

      return;
    }

    const zone = allZones.find((zone) => zone.zone_name === zoneName);
    const sampleZone = zone?.getSampleZone();
    const samples = sampleZone ? orderBy(sampleZone.getSampleSite()?.getSamples(), ['order'], ['asc']) : [];

    if (samples.length === 0) {
      alertWarn(`SET_ZONE_WAYPOINT - no samples found for zone ${zoneName}`);
      doneCallback();

      return;
    }

    await this.setWaypoint(StartAt.GoToSample, samples[0].sample_id, null, tag, doneCallback, coordinates);
  }

  async loadMissionSchedule(id: string) {
    const confirm = await alertConfirm('Are you sure you want to load this mission?', this.constructor.name);

    if (!confirm) {
      return;
    }

    const session = getCurrentSession();

    if (!session) {
      return;
    }

    await this.props.onLoading(async () => {
      this.resetRobotSettingsAndLockAccessLevel();

      Sentry.setTag('job_info', id);

      const record = LocalAtRecord.findOne<LocalAtRecord<JobsFieldSet>>(
        (record) => !!record && record.table === 'Jobs' && record.id === id,
      );

      try {
        console.log(
          `loadMissionSchedule - REFRESHING JOB RECORD "${record?.id}" ${record?.get('Name')} in Sampling Task`,
        );
        await record?.refresh();
      } catch (err) {
        alertWarn('Unable to refresh mission data');
      }

      if (record && (record.get('Offline Synced') || record.get('Sample Date Man OVRD Date'))) {
        await errorTone();
        const warnConfirm = await alertWarnConfirm(
          'WARNING! THIS MISSION HAS BEEN COMPLETED! IF YOU LOAD IT, YOU COULD LOSE SAMPLED DATA. ARE YOU SURE?',
        );

        if (!warnConfirm) {
          return;
        }
      }

      const today = new Date().toISOString().substring(0, 10);
      const notificationTimeString = record?.get('Operator En Route');
      const notificationDate = notificationTimeString
        ? new Date(notificationTimeString).toISOString().substring(0, 10)
        : undefined;
      const jobTextAlreadySentToday = notificationDate && notificationDate === today;
      const customerBoundaryRecording = session.getUser()?.customer_boundary_recording;

      if (!jobTextAlreadySentToday && !customerBoundaryRecording) {
        if (await alertConfirm('This job has not been notified for sampling. Are you sampling this field now?')) {
          await postCustomerNotification(id, [this.position?.x || 0, this.position?.y || 0]);
        }
      }

      const onRobot = this.state.robotState !== RobotState['Unknown'];

      // if on robot....
      if (onRobot) {
      }

      await SampleBox.logBoxes('BOXES_BEFORE_LOADING_MISSION_IN_SAMPLING');

      const missionLoader: IMissionLoader = new OriginalMissionLoader();
      logger.log(`SamplingTask: using the original mission loader to load job ${id}`);
      await session.loadMission(missionLoader, id, true);
      await SampleBox.logBoxes('BOXES_AFTER_LOADING_MISSION_IN_SAMPLING');
    });
  }

  showNavMessage(directionsLink: string, directionsSource: LatLonSource, jobInstanceId: number) {
    this.setState({
      navigationPopupVisible: true,
      navWarningDirections: directionsLink,
      growerNotificationPromptVisible: true,
      navigationJobInstanceId: jobInstanceId,
    });
  }

  /**
   * Loads the jobs from the schedule to be displayed
   * @param {boolean} forceRefresh Force airtable to pull from airtable api, pulls from cache by default
   * @param {boolean} userGenerated Used for debugging -- whether an event is the function was called from a user generated event
   */
  async loadSchedule(forceRefresh?: boolean, userGenerated?: boolean) {
    await SampleBox.logBoxes('BOXES_BEFORE_LOADING_SAMPLING_SCHEDULE');
    const logTimer = logger.start('LOAD_SCHEDULE', { forceRefresh, userGenerated });
    this.setState({ loadingSchedule: true });

    try {
      const session = getCurrentSession();
      const queryParams = `{Operator Email} = '${session?.getUser()?.email}'`;

      const jobsQueryPromise = getLocalAtSearch<JobsFieldSet>(
        'Jobs',
        AirtableViewIdLookup['Jobs'][JOBS_RUN_VIEW_NAME],
        queryParams,
        false,
      );

      const completedJobsQueryPromise = getLocalAtSearch<JobsFieldSet>(
        'Jobs',
        AirtableViewIdLookup['Jobs'][JOBS_COMPLETED_VIEW_NAME],
        queryParams,
        false,
      );

      const dropoffsQueryPromise = getLocalAtSearch<JobsFieldSet>(
        'Shift Dropoffs',
        AirtableViewIdLookup['Shift Dropoffs'][DROPOFF_VIEW_NAME],
        queryParams,
        false,
      );

      const [jobsResult, completedJobsResult, dropoffsResult] = await Promise.all([
        jobsQueryPromise,
        completedJobsQueryPromise,
        dropoffsQueryPromise,
      ]); // wait for all promises to resolve

      const shouldRefreshJobs = forceRefresh || jobsResult.getRecords().length === 0;
      const shouldRefreshDropoffs = forceRefresh || dropoffsResult.getRecords().length === 0;
      let jobRefreshWarning = false;

      try {
        if (shouldRefreshJobs) {
          await Promise.all([jobsResult.refresh(), completedJobsResult.refresh()]);
        }
      } catch (error) {
        jobRefreshWarning = true;
        alertError('Unable to refresh job schedule data');
      }

      try {
        if (shouldRefreshDropoffs) {
          await dropoffsResult.refresh();
        }
      } catch (error) {
        alertError('Unable to refresh dropoff schedule data');
      }

      const jobs = jobsResult.getRecords();
      const dropoffs = dropoffsResult.getRecords();
      const sampledJobs = completedJobsResult.getRecords();

      const jobLabs = jobs.map((job) => job.get('Lab - Final')?.replace(/"/g, ''));
      const uniqueLabs = [...new Set(jobLabs)];

      console.log(`Jobs: ${jobs.length}, Labs: ${JSON.stringify(uniqueLabs)}`);

      // TODO instruct the label controller to fill labels for these labs...

      let offlineJobIds: string[] = [];

      try {
        const offlineRecoveryFiles = await getRecoveryList({ count: 100, search: 'OFFLINE_' });

        if (offlineRecoveryFiles) {
          // TODO this needs to be removed/fixed, we shouldn't need this as statement
          offlineJobIds = extractRogoJobIDs(offlineRecoveryFiles as RecoveryFileListResponse);
        }
      } catch (err) {
        // unable to reach recovery server
        await logger.log('LOAD_SCHEDULE', { situation: 'Attempt to retrieve offline submitted jobs', err });
      }

      const offlineJobs = jobs.filter((record) => offlineJobIds.includes(record.id));
      sampledJobs.push(...offlineJobs);

      const sampled = jobs.filter((record) => Boolean(record.get('Sample Date Man OVRD Date')));
      sampledJobs.push(...sampled);

      // Only include jobs that are either offline OR NOT sampled already
      const items = [
        ...jobs.filter((record) => offlineJobIds.includes(record.id) || !sampled.includes(record)),
        ...dropoffs,
      ];

      await this.generateGeoJSON(items, sampledJobs, shouldRefreshJobs);

      // TODO filter items based on offline sync...
      // because we expect this to be rare, it would be fastest to just find all offline missions, and then compare against our job list
      //const offlineMissions = Mission.query((mission: Mission) => mission.offline_sync).map((mission) => mission.job_id);
      //this.setState({ scheduleItems: items.filter((record) =>  offlineMissions.includes(record.id))});

      // TODO filter out scheduleItems that have a sample date to deal with offline
      this.setState({ scheduleItems: items, sampledItems: sampledJobs, offlineItems: offlineJobs });

      if (forceRefresh && !jobRefreshWarning) {
        alertSuccess('Schedule successfully refreshed');
      }

      await logger.stop(logTimer, { success: true });
    } catch (err) {
      console.error('SamplingTask -> loadSchedule', err);

      // Check if this is an authorization error (e.g., job was deleted in Airtable)
      const isAuthError =
        err &&
        typeof err === 'object' &&
        (('error' in err && err.error === 'NOT_AUTHORIZED') || ('statusCode' in err && err.statusCode === 403));

      if (isAuthError) {
        alertError('Schedule could not be loaded. Some jobs may have been removed or you no longer have access.');
      } else {
        alertError('Schedule (s) failed to load. Check internet.');
      }

      await logger.stop(logTimer, { success: false });
    }

    this.setState({ loadingSchedule: false });

    await SampleBox.logBoxes('BOXES_AFTER_LOADING_SAMPLING_SCHEDULE');
  }

  /**
   * Redraws the schedule overlay against the job in hand. Opening or closing a
   * job changes which shift the field order follows, and the boundaries it works
   * from are already cached.
   */
  refreshScheduleFeatures = async () => {
    await this.generateGeoJSON(this.state.scheduleItems, this.state.sampledItems);
  };

  async generateGeoJSON(items: LocalAtRecord[], sampledJobs: LocalAtRecord<JobsFieldSet>[] = [], forceRefresh = false) {
    const features: ScheduleFeature[] = [];
    // Outline of each job's field, and where it wears its number, for the field
    // order overlay. Keyed by job, since the overlay works in shift order rather
    // than in the order the schedule hands the jobs over.
    const shapesByJobId = new Map<string, FieldShape>();
    const labelPointByJobId = new Map<string, [number, number] | null>();

    for (const item of items) {
      if (item.table === 'Jobs') {
        if (Boolean(item.get('Sample Date'))) {
          continue;
        }

        if (forceRefresh) {
          await item.refresh(); // to refresh item's attachments urls
        }

        features.push(genPullinGeoJSON(item));

        let result: Attachment | undefined;

        try {
          result = (await item.get_attachments('Bnd GeoJSON'))[0];
        } catch (error) {
          console.log('SamplingTask - generateGeoJSON - 2nd attempt getting attachments for item', item);
        }

        if (!result) {
          await item.refresh(); // to refresh item's attachments urls and attachments
          result = (await item.get_attachments('Bnd GeoJSON'))[0];
        }

        if (!result) {
          continue;
        }

        const jsonText = await result.text();

        try {
          const boundaryGeoJSON = JSON.parse(jsonText) as FeatureCollection<Polygon | MultiPolygon>;
          // The field is picked out before updateBoundaryProperties renames every
          // part to 'field'; the same geometries are reprojected in place, so the
          // outline is taken from them afterwards.
          const fieldParts = fieldGeometries(boundaryGeoJSON.features);
          updateBoundaryProperties(item, boundaryGeoJSON);
          features.push(...boundaryGeoJSON.features);

          const jobId = item.get('Rogo Job ID') ?? '';
          shapesByJobId.set(
            jobId,
            shapeFromParts(fieldParts, convertProjection4329([item.get('Lon'), item.get('Lat')])),
          );
          labelPointByJobId.set(jobId, fieldParts.length ? fieldLabelPoint(fieldParts[0]) : null);
        } catch (error) {
          console.error('SamplingTask -> generateGeoJSON - update boundary properties', error);
        }
      } else if (item.table === 'Shift Dropoffs') {
        const dropoffGeoJSON = genDropoffGeoJSON(item);
        features.push(...dropoffGeoJSON);
      } else {
        console.error(`Unknown schedule item: ${item.table}`);
      }
    }

    features.push(...this.genFieldOrder(items, sampledJobs, features, shapesByJobId, labelPointByJobId));

    this.setState({ scheduleFeatures: features });
  }

  /**
   * Numbers the shift's fields and connects them in working order, stamping each
   * job's number onto its own features so the field can wear it.
   *
   * Scope follows the job in hand: once one has been opened only its shift is
   * drawn. Before that the operator has not started, so every shift on the
   * schedule is drawn instead — each numbered from 1 on its own, never joined to
   * the next.
   *
   * @returns The hops to add to the schedule features.
   */
  genFieldOrder(
    items: LocalAtRecord[],
    sampledJobs: LocalAtRecord<JobsFieldSet>[],
    features: ScheduleFeature[],
    shapesByJobId: Map<string, FieldShape>,
    labelPointByJobId: Map<string, [number, number] | null>,
  ): ScheduleFeature[] {
    const mission = getCurrentMission();
    // Sampled jobs are finished work: not routed to, but they hold their place
    // in the shift so the numbers on the fields ahead never shift.
    const doneJobIds = new Set(sampledJobs.map((job) => job.get('Rogo Job ID')));
    const jobItems = items.filter((item) => item.table === 'Jobs') as LocalAtRecord<JobsFieldSet>[];
    const jobsById = new Map<string, LocalAtRecord<JobsFieldSet>>();

    for (const job of [...jobItems, ...sampledJobs]) {
      const jobId = job.get('Rogo Job ID');

      if (jobId) {
        jobsById.set(jobId, job);
      }
    }

    if (mission?.job_id && jobsById.has(mission.job_id)) {
      this.lastMissionID = mission.job_id;
    }

    const { orderByJobId, hops } = fieldOrderOverlay(
      [...jobsById.values()].map((job) => {
        const jobId = job.get('Rogo Job ID') ?? '';

        return {
          jobId,
          shiftId: job.get('Shift')?.[0],
          order: job.get('Order'),
          shape: shapesByJobId.get(jobId) ?? { rings: [] },
          labelPoint: labelPointByJobId.get(jobId) ?? null,
          done: doneJobIds.has(jobId),
        };
      }),
      mission?.job_id,
      this.lastMissionID || mission?.job_id,
    );

    // Each field carries its own number, so stamp it on the job's features.
    for (const feature of features) {
      const jobId = feature.properties?.['Rogo Job ID'];
      const order = orderByJobId.get(jobId);

      if (order && feature.properties) {
        feature.properties['Shift Order'] = order;
        feature.properties['Order Point'] = labelPointByJobId.get(jobId);
      }
    }

    return hops as ScheduleFeature[];
  }

  toggleTrackingOverride() {
    const trackingOverride = !this.state.trackingOverride;
    this.setState({ trackingOverride });
  }

  /**
   * Cleanup for the box exit interview
   * @param {object} switchedBox
   */
  async finishBoxExitInterview(switchedBox: boolean) {
    const box = this.state.boxToClose;
    const boxesNeedReprint = this.state.boxesNeedReprint.slice();

    if (switchedBox) {
      boxesNeedReprint.pop();
      this.setState({ boxesNeedReprint });
    }

    this.setState({ boxToClose: undefined });

    if (!box && boxesNeedReprint.length) {
      await this.handleCloseBox();
    }
  }

  downloadPdf() {
    if (this.state.boxPdf) {
      const link = document.createElement('a');
      link.href = this.state.boxPdf.dataUrl;
      link.download = this.state.boxPdf.downloadName;
      link.click();
    }
  }

  /**
   * Method that will remove box from state
   * @param {number} box The instance id of the box to close or dispose
   * @param {boolean} dispose Dispose the box instead of setting the close property
   */
  async closeBox(box: SampleBox, dispose: boolean = false) {
    await SampleBox.logBoxes('BOXES_BEFORE_CLOSING_BOX');

    if (dispose) {
      await box.dispose();
    } else {
      // TODO why are we setting the session ID to undefined here?
      // what does that gain us?
      box.Session_id = undefined;
      box.ReprintSession_id = undefined;
      box.closedTimestamp = new Date().toISOString();

      this.props.closeBox(box);
      saveDbToRecoveryServer(DB_SAVE_REASONS.BOX_CLOSED).catch((err) => {
        console.error('Failed to save DB to recovery server after box closed', err);
      });

      this.setState({ boxPdfPreviewVisible: false });
      const dontDispose = !dispose;

      // if no active mission or active mission is not in box, then upload the box
      const currentMission = getCurrentMission();
      const noCurrentMission = !currentMission;
      const currentMissionInBox = currentMission && box.getSampleBoxMissions().includes(currentMission);
      const currentMissionNotInBox = !currentMissionInBox;

      // if we aren't disposing the box AND
      //   we don't have a current mission OR
      //   the current mission is NOT in the box
      // then we should upload the box data. If the box gets updated before the
      // active mission is closed, then we can wait to let the mission upload
      // the box Otherwise, we should upload the box data now
      if (dontDispose && (noCurrentMission || currentMissionNotInBox)) {
        try {
          const result = await box.upload();

          if (!result) {
            await logger.log('CLOSE_BOX', `Attempted to upload dirty box data but failed: ${JSON.stringify(box)}`);
          }
        } catch (err) {
          console.error(err);
        }
      }
    }

    // If no mission is loaded, then we can select the next open box
    const openBoxes = SampleBox.getOpenBoxes();

    if (!getCurrentMission() && openBoxes.length) {
      const nextBox = openBoxes[0];
      nextBox.Session_id = getCurrentSession()?.instance_id;
      this.setState({ activeBox: nextBox, boxInstanceId: nextBox.instance_id });
    }

    dispatchActiveBoxUpdated();

    await SampleBox.logBoxes('BOXES_AFTER_CLOSING_BOX');
  }

  /**
   * Changes printer configuration to be used for PDF
   */
  handlePrinterSelect(printerConfig: PRINTER_CONFIG) {
    const printURL = getPrintURLFromConfig(printerConfig);
    console.log(printURL);
    this.setState({
      printerConfig: printerConfig,
      printURL: printURL,
    });
  }

  /**
   * Loads box data into state for display
   */
  async updateBoxData() {
    const box = SampleBox.getCurrentBox();
    const boxQuery = SampleBox.query();
    // TODO this is where we need to go away from using this temporary
    // data instance and start typing this
    const allBoxes = [...boxQuery];

    // if (!box && allBoxes.length) {
    //   const lastBox = allBoxes[allBoxes.length - 1].box;
    //   if (lastBox !== box) {
    //     box = lastBox;
    //     box.Session_id = getCurrentSession()?.instance_id;
    //   }
    // }
    if (box) {
      const boxMissionSet = Array.from(box.getSampleBoxMissions());
      const boxMissions = boxMissionSet.map((mission) => {
        const fieldName = mission.getJob()?.field || '';

        return {
          fieldName,
          instanceId: mission.instance_id,
          numSamples: flatten(
            mission.getSampleSites().map((site) => site.getSamples().filter((sample) => sample.bag_id)),
          ).length,
        };
      });
      this.setState({ activeBox: box, boxInstanceId: box.instance_id, boxMissions, allBoxes });

      return;
    } else {
      this.setState({ activeBox: undefined, boxInstanceId: undefined, boxMissions: [], allBoxes: [] });
    }
  }

  /**
   * Loads boxes that need reprinted
   */
  updateBoxNeedsReprint() {
    const session = getCurrentSession();

    if (session) {
      const boxes = session.getReprintSampleBoxes();
      const boxesNeedReprint = boxes.map((box) => {
        const boxMissionSet = box.getSampleBoxMissions();
        const boxMissions = boxMissionSet.map((mission) => {
          const fieldName = mission?.getJob()?.field || '';
          const numSamples = box.getSamples().length;

          return { fieldName, instanceId: mission.instance_id, numSamples };
        });

        return { boxId: box.uid, instanceId: box.instance_id, boxMissions };
      });

      this.setState({ boxesNeedReprint });
    }
  }

  render() {
    // TODO these shouldn't happen every render... but I don't want to put all of this in the state either
    let riskyNavigation = false;
    let jobNeedsNotified = false;

    // count photos by sample
    const photosByMetadata = this.state.currentMissionPhotos.map((photo) => {
      const [, , , filename] = photo.split('/');
      const [jobId, sampleId, , , ,] = filename.split('_');

      return { jobId, sampleId, photo };
    });

    // count photos by sampleId
    const photosBySampleId = photosByMetadata.reduce((acc, photo) => {
      if (!acc[photo.sampleId]) {
        acc[photo.sampleId] = [];
      }

      acc[photo.sampleId].push(photo);

      return acc;
    }, {});

    const navigationJob = LocalAtRecord.get(this.state.navigationJobInstanceId);

    const onRobot = this.state.robotState !== RobotState['Unknown'];
    // const viewOnlyApp = this.state.controlRole === 'view';

    let currentJobName = '';

    if (this.state.growerNotificationPromptVisible) {
      const todaysDate = new Date().toISOString().substring(0, 10);
      const notificationTimeString = navigationJob?.get('Operator En Route');
      currentJobName = navigationJob?.get('Name');
      const notificationDate = notificationTimeString
        ? new Date(notificationTimeString).toISOString().substring(0, 10)
        : undefined;
      const jobTextAlreadySentToday = notificationDate && notificationDate === todaysDate;

      const operatorInGrowerTextBeta = true; // getCurrentSession()?.getUser()?.user_flags?.includes('Grower Text Beta');
      const jobInGrowerTextBeta = getCurrentMission()?.getJob()?.job_flags?.includes('Grower Text Beta');

      jobNeedsNotified = (jobInGrowerTextBeta || operatorInGrowerTextBeta) && !jobTextAlreadySentToday;

      riskyNavigation = !navigationJob || (navigationJob.get('Lat Lon Source') as LatLonSource) !== 'NearestRoad';
    }

    const mission = getCurrentMission();

    return (
      <React.Fragment>
        {this.state.boxPdf && (
          <Modal
            open={Boolean(this.state.boxPdf) && this.state.boxPdfPreviewVisible}
            style={{ zIndex: 1500, overflow: 'scroll' }}
          >
            <React.Fragment>
              <PDFViewer
                fileUrl={this.state.boxPdf.dataUrl}
                downloadName={this.state.boxPdf.downloadName}
                onClose={() => {
                  console.log(`PDFView.onClose`);
                  this.downloadPdf();
                  this.setState({ boxPdf: undefined });
                }}
                printURL={this.state.printURL}
                onSuccess={() => alertSuccess('Print Job Sent Successfully - Check Printer Power and Paper')}
                onFailure={() => alertError('Print Job Failed to Send')}
              />
            </React.Fragment>
          </Modal>
        )}
        {/* Box exit interview for active box */}
        {this.state.boxToClose && (
          <BoxExitInterview
            onClose={async () => await this.finishBoxExitInterview(false)}
            closeBox={this.closeBox}
            isReprint={false}
            box={this.state.boxToClose}
            boxUid={this.state.boxToClose.uid}
            boxInstanceId={this.state.boxToClose.instance_id}
            boxMissions={this.state.boxMissions}
            openBoxExitInterview={this.handleCloseBox}
            accessLevel={this.props.accessLevel}
            handlePrinterSelect={this.handlePrinterSelect}
            printerConfig={this.state.printerConfig}
          />
        )}
        {/* Box exit interview for boxes that need reprinted */}
        {this.state.boxToClose && !this.state.activeBox && this.state.boxesNeedReprint.length > 0 && (
          <BoxExitInterview
            onClose={async () => await this.finishBoxExitInterview(true)}
            closeBox={this.closeBox}
            isReprint={true}
            box={SampleBox.get(this.state.boxesNeedReprint[this.state.boxesNeedReprint.length - 1].instanceId)!}
            boxUid={this.state.boxesNeedReprint[this.state.boxesNeedReprint.length - 1].boxId}
            boxMissions={this.state.boxesNeedReprint[this.state.boxesNeedReprint.length - 1].boxMissions}
            boxInstanceId={this.state.boxesNeedReprint[this.state.boxesNeedReprint.length - 1].instanceId}
            openBoxExitInterview={this.handleCloseBox}
            accessLevel={this.props.accessLevel}
            printerConfig={this.state.printerConfig}
            handlePrinterSelect={this.handlePrinterSelect}
          />
        )}
        {this.state.manualMeasurementDialogOpen && this.state.manualMeasurementDialogParameters && (
          <ManualMeasurementDialog
            title={this.state.manualMeasurementDialogParameters.title}
            imageSource={this.state.manualMeasurementDialogParameters.imageSource}
            initialValue={this.state.manualMeasurementDialogParameters.measurementParameters.initialValue}
            dismissDialog={
              this.state.manualMeasurementDialogParameters.showDismissButton
                ? () => {
                    this.setState({
                      manualMeasurementDialogOpen: false,
                      manualMeasurementDialogParameters: null,
                    });
                  }
                : undefined
            }
            suggestedMin={this.state.manualMeasurementDialogParameters.measurementParameters.suggestedMin}
            suggestedMax={this.state.manualMeasurementDialogParameters.measurementParameters.suggestedMax}
            absoluteMin={this.state.manualMeasurementDialogParameters.measurementParameters.absoluteMin}
            absoluteMax={this.state.manualMeasurementDialogParameters.measurementParameters.absoluteMax}
            sliderMarks={this.state.manualMeasurementDialogParameters.measurementParameters.benchmarks}
            onSave={(measurementCm) => {
              this.state.manualMeasurementDialogParameters?.onComplete(measurementCm);

              this.setState({
                manualMeasurementDialogOpen: false,
                manualMeasurementDialogParameters: null,
              });
            }}
          />
        )}
        {mission && (
          <SamplingEntranceInterview
            open={this.state.entranceInterviewDialogOpen}
            closeForm={() => this.setState({ entranceInterviewDialogOpen: false })}
            currentDepthOffset={this.state.drillDepthOffset}
            accessLevel={this.props.accessLevel}
            elevatePermissions={this.props.elevatePermissions}
          />
        )}
        {this.props.tab === 'mission' &&
          (this.state.missionView === 'standard' ? (
            <SamplingMissionView
              toggleScanner={this.toggleScanner}
              scannerActive={this.state.scannerActive}
              missionActive={this.props.missionActive}
              onLoading={this.props.onLoading}
              accessLevel={this.props.accessLevel}
              operatorNotesDialogOpen={this.state.operatorNotesDialogOpen}
              toggleNotesDialog={this.toggleNotesDialog}
              toggleHMIVisible={this.toggleHMIVisible}
              hmiVisible={this.state.hmiVisible}
              showNavMessage={this.showNavMessage}
              showRecoveryPopup={this.props.showRecoveryPopup}
              showDatabasesPopup={this.props.showDatabasesPopup}
              drillDepth={this.state.drillDepthDisplay}
              drillDepthOffset={this.state.drillDepthOffset}
              allBoxes={this.state.allBoxes}
              activeBox={this.state.activeBox}
              handleCloseBox={this.handleCloseBox}
              photosBySampleId={photosBySampleId}
              updateMissionView={(view: MissionView) => this.setState({ missionView: view })}
              robotConnected={this.props.connectionStatus === 'connected'}
              openEntranceInterview={() => this.setState({ entranceInterviewDialogOpen: true })}
              openManualMeasurementDialog={this.openManualMeasurementDialog}
              elevatePermissions={this.props.elevatePermissions}
              strictCoreEnforcement={this.state.strictCoreEnforcement}
              updateStrictCoreEnforcement={this.updateStrictCoreEnforcement}
            />
          ) : (
            <SamplingHelperView
              scheduleItems={this.state.scheduleItems}
              missionActive={this.props.missionActive}
              updateMissionView={(view: MissionView) => this.setState({ missionView: view })}
            />
          ))}
        {this.props.tab === 'schedule' && (
          <SampleScheduleView
            loadMissionSchedule={this.loadMissionSchedule}
            loadSchedule={this.loadSchedule}
            loadingSchedule={this.state.loadingSchedule}
            scheduleItems={this.state.scheduleItems}
            sampledItems={this.state.sampledItems}
            offlineItems={this.state.offlineItems}
            missionActive={this.props.missionActive}
            showNavMessage={this.showNavMessage}
            resubmitAll={this.resubmitAll}
          />
        )}
        {this.props.tab === 'map' && (
          <SamplingMap
            setWaypoint={this.setWaypoint}
            setZoneWaypoint={this.setZoneWaypoint}
            loadMissionSchedule={this.loadMissionSchedule}
            toggleScanner={this.toggleScanner}
            scannerActive={this.state.scannerActive}
            scheduleFeatures={this.state.scheduleFeatures}
            sampledItems={this.state.sampledItems}
            robotMission={this.state.robotMission}
            connectionStatus={this.props.connectionStatus}
            missionActive={this.props.missionActive}
            totalSamples={this.state.totalSamples}
            filledSamples={this.state.filledSamples}
            trackingOverride={this.state.trackingOverride}
            hmiVisible={this.state.hmiVisible}
            accessLevel={this.props.accessLevel}
            robotNavControlState={this.state.robotNavControlState}
            navigatingToSampleLocation={undefined}
            robotState={this.state.robotState}
            presentSample={this.state.presentSample}
            closeSample={this.state.closeSample}
            coresInBucket={mission?.getSoilCoresInBucket() || []}
            drillDepth={this.state.drillDepthDisplay}
            drillDepthOffset={this.state.drillDepthOffset}
            onLoading={this.props.onLoading}
            inBounds={this.state.inBounds}
            openManualMeasurementDialog={this.openManualMeasurementDialog}
            targetCoordinate={this.state.targetCoordinate}
          />
        )}
        {this.props.tab === 'boxes' && (
          <BoxHistoryView showBoxCloseScreen={this.handleCloseBox} accessLevel={this.props.accessLevel} />
        )}
        {this.props.tab === 'robot' && (
          <RobotPanel
            setDepth={this.setDepth}
            syncMission={this.syncMission}
            setWaypoint={this.setWaypoint}
            updateAutoSync={this.updateAutoSync}
            toggleTrackingOverride={this.toggleTrackingOverride}
            trackingOverride={this.state.trackingOverride}
            syncInProgress={this.state.syncInProgress}
            robotMission={this.state.robotMission}
            outOfSync={this.state.outOfSync}
            missionDepth={this.state.missionDepth}
            drillDepth={this.state.drillDepthDisplay}
            depthLocked={this.state.depthLocked}
            lastSyncTimestamp={this.state.lastSyncTimestamp}
            autoSync={this.state.autoSync}
            devMode={this.props.accessLevel === 'Technician'}
            connectionStatus={this.props.connectionStatus}
            elevatePermissions={this.props.elevatePermissions}
            accessLevel={this.props.accessLevel}
            hmiVisible={this.state.hmiVisible}
            toggleHMIVisible={this.toggleHMIVisible}
          />
        )}
        <Robots task={TaskName.SAMPLING} />
        <SlideoutTextBox
          dialogOpen={this.state.operatorNotesDialogOpen}
          message={this.state.operatorNotes}
          closeDialog={this.closeNotesDialog}
          title="MISSION NOTES:"
          expandedWidth="300px"
        />
        <Dialog
          disableEscapeKeyDown
          maxWidth={'sm'}
          open={this.state.growerNotificationPromptVisible || false}
          onClose={(_event, reason) => {
            if (reason === 'backdropClick') {
              return;
            }

            this.setState({
              growerNotificationPromptVisible: false,
            });
          }}
        >
          <DialogTitle>{currentJobName}</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid>
                {!riskyNavigation && !jobNeedsNotified && (
                  <ListItemText>Directions are ready, please click to navigate</ListItemText>
                )}
                {riskyNavigation && (
                  <ListItemText>
                    <b>
                      Warning! This mission does not have a reliable navigation point. Please review the map near your
                      destination
                    </b>
                  </ListItemText>
                )}

                {jobNeedsNotified && (
                  <ListItemText>
                    Are you going to sample this field next? If so, we will contact the customer to let them know you're
                    on the way.
                  </ListItemText>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              spacing={1}
              direction={isMobile ? 'column' : 'row'}
              size={12}
            >
              {jobNeedsNotified && (
                <Grid
                  size={{
                    xs: 12,
                    sm: 5,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      await this.props.onLoading(async () => {
                        this.setState({ growerNotificationPromptVisible: false });

                        // open the directions link
                        const link = document.createElement('a');
                        link.href = this.state.navWarningDirections;
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        setTimeout(async () => {
                          logger.log('JOBS_NOTIFICATIONS', 'Start feedback timeout for sending notifications');
                          // TODO it would be nice if we could just use the current user position, or possibly the robot position?
                          let position: Coordinate = [0, 0];

                          try {
                            position = await getUserPosition({ enableHighAccuracy: false });
                          } catch (err) {
                            // do nothing as getUserPosition warns already
                          }

                          if (navigationJob?.id) {
                            await postCustomerNotification(navigationJob.id, position, onRobot);
                          }
                        });
                      });
                    }}
                  >
                    Notify + Navigate
                  </Button>
                </Grid>
              )}
              <Grid
                size={{
                  xs: 12,
                  sm: 5,
                }}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    this.setState({ growerNotificationPromptVisible: false });
                    const link = document.createElement('a');
                    link.href = this.state.navWarningDirections;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  {jobNeedsNotified ? "Navigate (Don't Notify)" : riskyNavigation ? 'Navigate Anyways' : 'Navigate'}
                </Button>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.setState({ growerNotificationPromptVisible: false });
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        {Boolean(this.state.reasonSelectorOptions) && (
          <ChangeTypeReasonSelector
            onClose={async (result, { enteredReason, selectedChangeType }) => {
              const resultPayload: ChangeReasonPopupResult = { result, selectedChangeType, reason: enteredReason };
              EventBus.dispatch(CHANGE_EVENTS.CHANGE_REASON_SELECTOR_CLOSED, JSON.stringify(resultPayload));
              this.setState({ reasonSelectorOptions: undefined });
            }}
            clearBarcode={async function (sampleInstanceId: number): Promise<void> {
              const errMap = await setSampleBarcodes(sampleInstanceId, '', true); // set samples in db
              await checkGapError(errMap);
              const sampleId = Sample.get(sampleInstanceId)?.sample_id;

              if (sampleId) {
                dispatchSamplesUpdated([sampleId]);
              }

              return;
            }}
            {...this.state.reasonSelectorOptions}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  closeBox,
};

export default connect(null, mapDispatchToProps)(SamplingTask);
